var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"text-truncate",class:{ 'subtitle-2': _vm.bold, 'font-italic': _vm.italic },domProps:{"innerHTML":_vm._s(_vm.text)}},on))]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.hoverText || _vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }